import { deleteKeysObject, KeysOfDB_Object, tsValidate, tsValidateArray, tsValidateExists, tsValidateOptionalId, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { findingViewGeneratedKeys, findingViewType_Parent, findingViewType_Sections } from './types.js';
import { DBDef_ContextRule, DBDef_Variable, knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_AdvisorWizard } from '@app/advisor-content-shared';
import { Validator_SectionSortMethod } from '../../_enum/section-sort-method/validation.js';
import { sectionRenderMethods } from '../../_enum/finding-view-section/types.js';
import { Validator_FindingViewSection } from '../../_enum/finding-view-section/validation.js';
const Validator_FindingView_Parent = {
    type: tsValidateValue([findingViewType_Parent]),
    label: tsValidateString(),
    childrenIds: tsValidateArray(tsValidateUniqueId),
    wizardId: tsValidateOptionalId,
};
// @ts-ignore
const Validator_FindingView_Sections = {
    type: tsValidateValue([findingViewType_Sections]),
    label: tsValidateString(),
    sections: tsValidateArray(Validator_FindingViewSection),
    sectionRenderMethod: tsValidateValue([...sectionRenderMethods]),
    sectionSortMethod: Validator_SectionSortMethod,
    wizardId: tsValidateOptionalId,
};
const Validator_ModifiableProps = (item) => {
    if (!item)
        return tsValidateExists()(item);
    const toValidate = deleteKeysObject(item, [...KeysOfDB_Object, ...findingViewGeneratedKeys]);
    switch (item.type) {
        case findingViewType_Parent:
            return tsValidate(toValidate, Validator_FindingView_Parent);
        case findingViewType_Sections:
            return tsValidate(toValidate, Validator_FindingView_Sections);
        default:
            return `Missing validation for finding view of type ${item.type}`;
    }
};
const Validator_GeneratedProps = {
    __variableIds: tsValidateArray(tsValidateUniqueId),
    __findingViewIds: tsValidateArray(tsValidateUniqueId),
    __contextRuleIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_FindingView = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'finding-view-v2',
    entityName: 'finding-view-v2',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'finding-view-v2'
    },
    backend: {
        name: 'finding-view-v2'
    },
    dependencies: {
        __variableIds: {
            dbKey: DBDef_Variable.dbKey,
            fieldType: 'string[]',
        },
        __findingViewIds: {
            dbKey: 'finding-view-v2',
            fieldType: 'string[]',
        },
        __contextRuleIds: {
            dbKey: DBDef_ContextRule.dbKey,
            fieldType: 'string[]',
        },
        wizardId: {
            dbKey: DBDef_AdvisorWizard.dbKey,
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map